/** @file Export request to REST query: flat option keys (folded into options by the Worker), arrays repeated. */
import type { ExportRequestOptions } from '@pose2d/api/export/exportTypes';

/** What the export dialog sends: the options as the export tool takes them, plus verify. */
export interface ExportRequest {
  options: ExportRequestOptions;
  verify: boolean;
}

type Flat = string | number | boolean | readonly string[] | undefined;

/** `target=spritesheet&animations=walk&animations=run&verify=true`; undefined options are left out. */
export function exportQuery(request: ExportRequest): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(request.options) as [string, Flat][]) {
    if (typeof value === 'object') for (const item of value) query.append(key, item);
    else if (value !== undefined) query.append(key, String(value));
  }
  query.append('verify', String(request.verify));
  return query.toString();
}
